import util from "../util/util";

export default function podFormValidation(report) {
  // returned, defines if we have errors or not;
  let hasErrors = false;

  // returned, used to setState to inform the users of the errors;
  const errors = {};

  if (report.name === ``) {
    errors.name = "Pod Name is a required field.";
    hasErrors = true;
  }

  // if it's a url, make sure it is valid;
  if (report.source === 1 && testForValidUrl(report.sourceUrl) === false) {
    errors.sourceUrl = true;
    hasErrors = true;
  }

  // need new validation with the file change (file won't change);
  if (
    report.source === 2 &&
    (report.sourceFile === `` ||
      report.sourceFile === util.podFormDefaultSourceFile)
  ) {
    errors.sourceFile = true;
    hasErrors = true;
  }

  // if the file is still uploading;
  if (report.source === 2 && report.showProgressBar) {
    errors.sourceFile = true;
    errors.uploading = true;
    hasErrors = true;
  }

  // if the file is too large;
  if (report.filesize > util.podFormMaxFilesize) {
    errors.sourceFile = true;
    hasErrors = true;
  }

  // if we have rows without elementIds;
  if (report.elements) {
    let elementIds = [];
    report.elements.forEach(function(element, index) {
      elementIds.push(element.element_id);
      if (element.element_id.length === 0) {
        // the first row is a special case
        if (index === 0) {
          if (
            element.protrack_id.length > 0 ||
            element.client_name.length > 0 ||
            element.spot_name.length > 0 ||
            element.tape.length > 0 ||
            element.order.length > 0 ||
            element.duration.length > 0
          ) {
            errors["element" + index] = true;
            hasErrors = true;
          }
        } else {
          errors["element" + index] = true;
          hasErrors = true;
        }
      }
    });
    // check element ids uniqueness within the pod
    elementIds = elementIds.filter(x => x);
    if (new Set(elementIds).size < elementIds.length) {
      hasErrors = true;
      errors["elements"] = true;
    }
  }

  // check total duration
  if (
    report.source === 3 &&
    (report.totalDuration > util.podFormMaxDuration ||
      report.totalDuration < util.podFormMinDuration)
  ) {
    errors.spots = true;
    hasErrors = true;
  }

  return {
    errors: errors, // return for setState to tell the user what went wrong;
    hasErrors: hasErrors // return true/false so the submit works/doesn't;
  };
}

// regex to validate a URL;
function testForValidUrl(url) {
  // eslint-disable-next-line
  const pattern = /^(http|https):\/\/(([a-zA-Z0-9$\-_.+!*'(),;:&=]|%[0-9a-fA-F]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Z0-9\-\u00C0-\u017F]+\.)+([a-zA-Z]{2,}))(:[0-9]+)?(\/(([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*(\/([a-zA-Z0-9$\-_.+!*'(),;:@&=]|%[0-9a-fA-F]{2})*)*)?(\?([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?(\#([a-zA-Z0-9$\-_.+!*'(),;:@&=\/?]|%[0-9a-fA-F]{2})*)?)?$/;

  return pattern.test(url);
}
